import { FacilityInfrastructureModel } from "./facility-infrastructure.model"
import { FacilityTranslatableDetailsModel } from "./facility-translatable-details.model"
import { ParkingLotModel } from './parking-lot.model'

export class FacilityModel {
  id!: string
  name!: string
  capacity!: number
  free!: number
  street!: string
  streetNumber!: string
  postalCode!: string
  city!: string
  longitude!: string
  latitude!: string
  thumbnail!: Media
  map!: Media
  carousel!: Media[]
  priceHourly!: number
  priceDaily!: number
  translatableDetails!: FacilityTranslatableDetailsModel[]
  distance!: number
  height!: number
  numberOfGates!: number
  keycode!: number
  internalComments!: string
  facilityInfrastructures!: FacilityInfrastructureModel[]
  parkingLots!: ParkingLotModel[]

  get occupied(): number {
    return this.capacity - this.free
  }
}
export interface Media {
  id: number
  path: string
}
